export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="relative bg-gradient-to-b from-[#0e0c1e] to-[#060410] border-t border-[#e879f9]/15 overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#e879f9]/40 to-transparent" />
      <div className="absolute top-0 left-1/4 w-96 h-32 bg-[#e879f9]/3 blur-3xl" />
      <div className="absolute top-0 right-1/4 w-96 h-32 bg-[#22d3ee]/3 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 pt-16 pb-8">
        {/* Top Row */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/8d3920c3-79a6-4087-8e00-e450527d6780.png"
                alt="Aidan Barrett Logo"
                className="w-10 h-10 object-contain rounded-full border border-[#e879f9]/30"
              />
              <span className="font-orbitron text-base font-black uppercase tracking-widest neon-text-fuchsia">
                Aidan Barrett
              </span>
            </div>
            <p className="font-rajdhani text-sm text-slate-400 leading-relaxed max-w-sm mb-5">
              Pro gamer, content creator, and full-time streamer. Bringing the best gaming content across platforms — come join the community.
            </p>
            {/* Social icons */}
            <div className="flex items-center gap-3 flex-wrap">
              {[
                { icon: "ri-twitch-fill", color: "#9147ff", href: "#" },
                { icon: "ri-youtube-fill", color: "#ff0000", href: "#" },
                { icon: "ri-twitter-x-fill", color: "#e2e8f0", href: "#" },
                { icon: "ri-discord-fill", color: "#5865f2", href: "#" },
                { icon: "ri-tiktok-fill", color: "#ff0050", href: "#" },
                { icon: "ri-instagram-fill", color: "#e1306c", href: "#" },
              ].map((s, i) => (
                <a
                  key={i}
                  href={s.href}
                  className="w-9 h-9 flex items-center justify-center rounded-lg border border-white/10 bg-white/3 hover:border-white/25 hover:bg-white/8 transition-all duration-300 cursor-pointer"
                  style={{ color: s.color }}
                >
                  <i className={`${s.icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-orbitron text-xs font-bold uppercase tracking-widest text-white mb-5">Navigation</h4>
            <ul className="space-y-2.5">
              {[
                { label: "Hero", href: "#hero" },
                { label: "About Me", href: "#about" },
                { label: "Game Highlights", href: "#highlights" },
                { label: "Live Streams", href: "#streams" },
                { label: "Social Media", href: "#socials" },
                { label: "Contact", href: "#contact" },
              ].map((link) => (
                <li key={link.href}>
                  <button
                    onClick={() => scrollTo(link.href)}
                    className="font-rajdhani text-sm text-slate-400 hover:text-[#e879f9] transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Stats */}
          <div>
            <h4 className="font-orbitron text-xs font-bold uppercase tracking-widest text-white mb-5">Quick Stats</h4>
            <ul className="space-y-3">
              {[
                { label: "Twitch Followers", val: "42.8K" },
                { label: "YouTube Subs", val: "128K" },
                { label: "TikTok Followers", val: "215K" },
                { label: "Hours Streamed", val: "4,200+" },
              ].map((s) => (
                <li key={s.label} className="flex items-center justify-between">
                  <span className="font-rajdhani text-xs text-slate-500">{s.label}</span>
                  <span className="font-mono-tech text-xs text-[#22d3ee]">{s.val}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px w-full bg-gradient-to-r from-transparent via-[#e879f9]/20 to-transparent mb-6" />

        {/* Bottom row */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="font-mono-tech text-xs text-slate-600">
            &copy; {new Date().getFullYear()} Aidan Barrett. All rights reserved.
          </p>
          <div className="flex items-center gap-1">
            <span className="w-1.5 h-1.5 rounded-full bg-[#e879f9] animate-pulse inline-block" />
            <span className="font-mono-tech text-xs text-slate-600">
              Built for gaming. Designed for <span className="neon-text-fuchsia">greatness</span>.
            </span>
          </div>
          <div className="flex items-center gap-4">
            <a href="#" className="font-mono-tech text-xs text-slate-600 hover:text-slate-400 transition-colors cursor-pointer whitespace-nowrap">Privacy</a>
            <a href="#" className="font-mono-tech text-xs text-slate-600 hover:text-slate-400 transition-colors cursor-pointer whitespace-nowrap">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
